import React from 'react'

import {AddUser_Manager} from "../../model/manager"
import UserToAdd from "../../model/add-user"
import CheckBox, {CheckboxType} from "../../../../gd-components/checkbox/checkbox"
import UserIcon from "../../../../gd-ui/icon/user/user"

type Props = {
    className?  : string

    manager     : AddUser_Manager
}

export default function ModalAddUser_AddToTask(props: Props) {

    const isMultiselectEnabled = props.manager.multiselect

    const toggleUser = (userToAdd:UserToAdd) => {
        if (!isMultiselectEnabled) {
            props.manager.unselectAll()
        }

        userToAdd.toggleIsSelected()
        props.manager.reRender()
    }

    return (
        <>
            <div className="ui5-tabled-dashed w-100p">
                <div className="table-header">
                    <div className="cell flex-1">
                        <div className="ui5-title-small">
                            Project Users
                        </div>
                    </div>
                </div>

                {_.isEmpty(props.manager.projectUsersToAdd.available) &&
                    <div className="table-row">
                        <div className="flex-row-center-center ui5-txt-not-important">
                            No users found
                        </div>
                    </div>}

                {_.map(props.manager.projectUsersToAdd.available, (userToAdd:UserToAdd, key:number)=>{
                    const rowClasses = Classes("table-row", {
                        'ui5-bg-gray'   : userToAdd.isSelected,
                        'p-l-5'         : !isMultiselectEnabled
                    })

                    return (
                        <div key={key} className={rowClasses} onClick={toggleUser.bind(null, userToAdd)}>
                            <div className="cell flex-1 flex-row-left-center">
                                {isMultiselectEnabled &&
                                    <CheckBox className = "m-r-10 m-l-5"
                                              type      = {CheckboxType.FILLED}
                                              isChecked = {userToAdd.isSelected} />}
                                <UserIcon className = "m-r-8"
                                          size      = "22"
                                          userId    = {userToAdd.id}/>
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
